import React, { useCallback, useEffect, useState } from 'react';
import { notesApi } from '@/lib/notesApi';
import { TagLockedScreen } from './TagLockedScreen';

// Tag domain: while the portal is locked, every page (login, workspace, QR scan, shared list) shows maintenance.
export function TagMaintenanceGate({ children }) {
  const [locked, setLocked] = useState(null);
  const check = useCallback(() => {
    notesApi.get('/public/portal-status').then(({ data }) => {
      setLocked(!!data?.locked);
      // Sessions started before the lock are signed out, as before.
      if (data?.locked && localStorage.getItem('notes_token')) {
        const drop = () => ['notes_token', 'notes_user', 'tagws_company'].forEach((k) => localStorage.removeItem(k));
        notesApi.get('/notes/tag-workspace/lock-status').then(({ data: s }) => { if (s?.session_ended) drop(); }).catch((e) => {
          if (e?.response?.status === 401) drop();
        });
      }
    }).catch(() => setLocked((v) => !!v));
  }, []);
  useEffect(() => {
    check();
    const iv = setInterval(check, 15000);
    window.addEventListener('focus', check);
    window.addEventListener('tagws-locked', check);
    window.addEventListener('tagws-session-ended', check);
    return () => {
      clearInterval(iv);
      window.removeEventListener('focus', check);
      window.removeEventListener('tagws-locked', check);
      window.removeEventListener('tagws-session-ended', check);
    };
  }, [check]);
  if (locked === null) return null;
  return locked ? <TagLockedScreen /> : children;
}
